export class TeamNotFoundError extends Error {
    constructor(id) {
        super(`Team with id ${id} not found.`);
    }
}
